import axios from 'axios';
import { baseUrl } from '../utils/constants';

export const chunkedUploadStart = async (formData) => axios.post(
  `${baseUrl()}uploads/chunkedUpload/`,
  formData,
  {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  },
);

export const chunkedUpload = async (formData, { start, end, total }) => axios.post(
  `${baseUrl()}uploads/chunkedUpload/`,
  formData,
  {
    headers: {
      'Content-Type': 'multipart/form-data',
      'Content-Range': `bytes ${start}-${end}/${total}`,
    },
  },
);

export const chunkedUploadComplete = async (formData) => axios.post(
  `${baseUrl()}uploads/chunkedUploadComplete/`,
  formData,
  {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  },
);
